/**
 * @generated SignedSource<<20f5374681eaaa31375c0743986fe85c>>
 * @relayHash 3cd0c48224fc0a0f906a41fc085663de
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/569.0.0-2026-07-21T15:16:11.496Z/creatorsRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type creatorsRootQuery$variables = {
  hasCreatorsAttribute: boolean;
  nationality?: string | null;
  style?: string | null;
  vertical: VerticalType;
};
export type creatorsRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"CreatorsWrapper_viewer" | "formatCreatorsAttribute_viewer">;
  };
};
export type creatorsRootQuery = {
  response: creatorsRootQuery$data;
  variables: creatorsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasCreatorsAttribute"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nationality"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "style"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vertical"
},
v4 = [
  {
    "kind": "Literal",
    "name": "names",
    "value": [
      "creatorNationality",
      "creatorStyle"
    ]
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "vertical",
  "variableName": "vertical"
},
v9 = [
  (v8/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "creatorsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreatorsWrapper_viewer"
          },
          {
            "condition": "hasCreatorsAttribute",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "formatCreatorsAttribute_viewer",
                "selections": [
                  {
                    "alias": null,
                    "args": (v4/*:: as any*/),
                    "concreteType": "CreatorProp",
                    "kind": "LinkedField",
                    "name": "creatorProperties",
                    "plural": true,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": "creatorProperties(names:[\"creatorNationality\",\"creatorStyle\"])"
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "creatorsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "TopCreatorsList",
            "kind": "LinkedField",
            "name": "topCreators",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TopCreator",
                "kind": "LinkedField",
                "name": "creators",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image",
                    "storageKey": null
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "nationality",
                "variableName": "nationality"
              },
              {
                "kind": "Variable",
                "name": "style",
                "variableName": "style"
              },
              (v8/*:: as any*/)
            ],
            "concreteType": "CreatorGroup",
            "kind": "LinkedField",
            "name": "groupedCreators",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CreatorFacetType",
                "kind": "LinkedField",
                "name": "creators",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v9/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "CreatorProp",
            "kind": "LinkedField",
            "name": "creatorProperties",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": "creatorProperties(names:[\"creatorNationality\",\"creatorStyle\"])"
          },
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/569.0.0-2026-07-21T15:16:11.496Z/creatorsRootQuery",
    "metadata": {},
    "name": "creatorsRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8ed24fa91c21dc675ed7487ac95bd8ce";

export default node;
